var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.224,
    height: 69.613,
    viewBox: "0 0 54.224 69.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_44",
    "data-name": "Komponente 10 \\u2013 44",
    transform: "translate(0.1 0.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fire",
    transform: "translate(-64.009 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35492",
    "data-name": "Gruppe 35492",
    transform: "translate(64.009 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46785",
    "data-name": "Pfad 46785",
    d: "M108.173,35.121l-.042-.577c-.676-8.8-4.772-14.314-8.387-19.179C96.4,10.861,93.508,6.97,93.508,1.23A1.231,1.231,0,0,0,92.84.137a1.217,1.217,0,0,0-1.277.094A31.262,31.262,0,0,0,80.025,16.908a54.441,54.441,0,0,0-1.264,12.466c-5.013-1.071-6.148-8.569-6.16-8.651a1.229,1.229,0,0,0-1.754-.933c-.263.127-6.452,3.272-6.812,15.83-.025.418-.026.835-.026,1.254a22.124,22.124,0,1,0,44.248,0C108.257,36.263,108.215,35.691,108.173,35.121Zm-22.04,21.42a7.635,7.635,0,0,1-7.375-7.856c0-.148,0-.3.01-.479a9.965,9.965,0,0,1,.777-3.9,4.49,4.49,0,0,0,4.058,2.94,1.228,1.228,0,0,0,1.229-1.229,24.59,24.59,0,0,1,.472-5.591,11.879,11.879,0,0,1,2.488-4.712,15.839,15.839,0,0,0,2.534,4.649c1.422,2.021,2.893,4.111,3.151,7.675.016.211.031.424.031.652A7.636,7.636,0,0,1,86.133,56.541ZM93.9,54.935a10.533,10.533,0,0,0,2.065-6.25c0-.289-.018-.558-.054-1.061-.292-4.013-2.036-6.493-3.576-8.681-1.312-1.863-2.444-3.472-2.444-5.756a1.229,1.229,0,0,0-1.97-.981,14.359,14.359,0,0,0-5.01,7.642,22.5,22.5,0,0,0-.516,4.362,5.838,5.838,0,0,1-1.119-2.639,1.232,1.232,0,0,0-1.779-.928c-.31.158-3.031,1.719-3.187,7.459-.011.195-.012.389-.012.582a10.533,10.533,0,0,0,2.065,6.25,19.691,19.691,0,0,1-11.9-18.06c0-.369,0-.736.024-1.145C66.7,28.362,69.06,24.709,70.6,23.1c1.073,3.841,3.884,8.862,9.389,8.862a1.228,1.228,0,0,0,1.229-1.229A54.876,54.876,0,0,1,82.409,17.51,29.166,29.166,0,0,1,91.2,3.65c.685,5.265,3.553,9.125,6.567,13.181,3.583,4.823,7.287,9.81,7.908,17.886l.042.588c.038.511.078,1.022.078,1.57A19.692,19.692,0,0,1,93.9,54.935Z",
    transform: "translate(-64.009 0.001)",
    fill: "#2ecf96",
    stroke: "#2ecf96",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35493",
    "data-name": "Gruppe 35493",
    transform: "translate(-339.876 -2891.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,12.413V14.5H6.583l6.144-6.144L10.644,6.27Zm9.838-5.671a.553.553,0,0,0,0-.783l-1.3-1.3a.553.553,0,0,0-.783,0L11.238,5.675l2.083,2.083,1.017-1.017Z",
    transform: "translate(369.5 2936.504)",
    fill: "#2ecf96"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro1);
export default __webpack_public_path__ + "static/media/Pro1.9fc8c46d551abaed25543f4cd7575144.svg";
export { ForwardRef as ReactComponent };